<app-banner [heading]="'MEET OUR TEAM'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>
<section class="events3">
  <div class="container" data-aos="fade-up">
    <div class="row"><!-- ======= Grade I ======= -->
      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/1.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Kimti Lal Watta</h5>

            <p class="font-italic text-center">Chairman</p>
            <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
          </p> -->
          </div>
        </div>
      </div>
      <!-- ======= Blank ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card"></div>
      </div>
      <!-- ======= Blank ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="assets/img/about/principal2.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Hari Prakash Badoni</h5>

            <p class="font-italic text-center">Principal<br>
              <!-- M.A Geo (hons), M.ed, <br> 25 year experience<br> -->
              <!-- Ex.H.O.D. ( Eng, Eco)<br> -->
              <!-- St .Xavier’s Hr.Sec. School<br>
  Mohali (1995-2011)<br>
  Ex Principal , Saupin’s School,<br>
  Panchkula (2011-2020)  -->
            </p>
            <!-- <p class="card-text">Sed ut perspiciatis unde omnis iste natus error sit voluptatem doloremque laudantium, totam rem 
          </p> -->
          </div>
        </div>
      </div>
      <!-- ======= Blank ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card"></div>
      </div>
      <!-- ======= Blank ======= --><!-- ======= Grade II ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/3.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Priyanka Oberoi</h5>

            <p class="designation">Office Manager</p>

            <p class="experience">M.Sc. Computer Science , M.A. English</p>
          </div>
        </div>
      </div>
      <!-- ======= Blank ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card"></div>
      </div>
      <!-- ======= Blank ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\shikha.jpg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Shikha Sharma</h5>

            <p class="designation">Front Desk Manager</p>

            <!-- <p class="experience">BBA , MBA<br>
              Experiece-3 Years</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/5.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Simple</h5>

            <p class="designation">IT Incharge</p>

            <p class="designation">TGT</p>

            <p class="experience">M.Sc, M.C.A, (NIOS)B.Ed<br>
              Experience - 10 years&nbsp;</p>
          </div>
        </div>
      </div>
      <!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src=""></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Bharat</h5>

            <p class="designation">Accountant</p>

            <p class="experience">B.Com.<br>
              Experience – 5&nbsp;Years</p>
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\pardeep.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Pardeep</h5>

            <p class="designation">Clerk</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<app-banner [heading]="'FACULTY'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<section class="events3">
  <div class="container">
    <div class="row d-flex justify-content-between">
      <!-- ======= Grade II ======= --><!-- ======= Grade II ======= --><!-- ======= Grade III ======= -->
      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\jyoti.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Jyoti</h5>

            <p class="designation">Educator</p>
            <!-- 
            <p class="designation">TGT</p>

            <p class="experience">M.Sc.(Maths) , B.Ed.<br>
              Experience – 1 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\megha.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Megha</h5>
            <p class="designation">Educator</p>

            <!-- <p class="designation">TGT</p> -->


          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/8.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Aastha</h5>

            <p class="designation">Grade Incharge 10</p>

            <p class="designation">Club Coordinator</p>

            <p class="designation">TGT</p>

            <p class="experience">M.Sc. , B.Ed.<br>
              Experience – 2 Years</p>
          </div>
        </div>
      </div> -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\vimal.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Vimal</h5>

            <p class="designation">Educator</p>

            <!-- <p class="designation">House Mistress</p>

            <p class="designation">Coleridge House</p>

            <p class="designation">TGT</p>

            <p class="experience">M.A. , B.Ed.<br>
              Experience – 8 Years</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\preeti.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Preeti</h5>

            <p class="designation">Coordinator</p>

            <!-- <p class="designation">Grade Incharge 8</p>

            <p class="designation">TGT</p>

            <p class="experience">M.A. , B.Ed.<br>
              Experience –&nbsp; 4 Years</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/11.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Pooja Saini</h5>

            <p class="designation">Grade Incharge 7</p>

            <p class="designation">House Mistress</p>

            <p class="designation">Shakespeare House</p>

            <p class="designation">TGT</p>

            <p class="experience">M.Sc. , B.Ed.<br>
              Experience – 1 Year</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/12.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Mandeep Kaur</h5>

            <p class="designation">Coordinator Pre Nur to Grade 3</p>

            <p class="designation">Grade Incharge 6</p>

            <p class="designation">TGT</p>

            <p class="experience">B.Tech. , B.Ed.<br>
              Experience – 7 Years</p>
          </div>
        </div>
      </div> -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\shikha.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Shikha</h5>

            <!-- <p class="designation">Grade Incharge 5</p> -->

            <p class="designation">Coordinator</p>
<!-- 
            <p class="designation">PRT</p>

            <p class="experience">B.Tech , B.Ed.<br>
              Experience –&nbsp; 4 Years</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\sonia.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Sonia Samdhyan</h5>

            <p class="designation">Educator</p>

            <!-- <p class="designation">Wellness Teacher</p>

            <p class="experience">Wellness Diploma,M.A.<br>
              Experience –&nbsp; 1 Year</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/15.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Himani</h5>

            <p class="designation">Grade Incharge 3 Aster</p>

            <p class="designation">PRT</p>

            <p class="experience">M.C.A. , B.Ed.<br>
              Experience –&nbsp; 6 Months</p>
          </div>
        </div>
      </div> -->



      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\sakshi.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Sakshi</h5>

            <p class="designation">Examination Incharge</p>

            <!-- <p class="designation">House Mistress</p>

            <p class="designation">Wordsworth House</p>

            <p class="designation">PRT</p>

            <p class="experience">B.Pharma , B.Ed.<br>
              Experience – 2 Years 6 Months</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/16.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Sonika</h5>

            <p class="designation">Grade Incharge 2 Blueberry</p>

            <p class="designation">PRT</p>

            <p class="experience">M.Com , B.Ed.<br>
              Experience –&nbsp;6 Months</p>
          </div>
        </div>
      </div> -->


      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\lalita.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Lalita</h5>

            <p class="designation">Educator</p>
<!-- 
            <p class="designation">NTT</p>

            <p class="experience">M.B.A. , N.T.T., B.Ed.<br>
              Experience – 7 Years 6 Months</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/18.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Pallavi</h5>

            <p class="designation">Grade Incharge L.K.G</p>

            <p class="designation">PRT</p>

            <p class="experience">M.B.A. , B.Ed.<br>
              Experience –&nbsp;6 Months</p>
          </div>
        </div>
      </div> -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\Anu.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Anu</h5>

            <p class="designation">Educator</p>

            <!-- <p class="designation">NTT</p>

            <p class="experience">M.Com . ,N.T.T<br>
              Experience – 3 Years</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/20.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Aaki</h5>

            <p class="designation">Grade Incharge Nur Blueberry</p>

            <p class="designation">PRT</p>

            <p class="experience">B.Sc Comp. science<br>
              Experience –&nbsp;1 Year</p>
          </div>
        </div>
      </div> -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\sunita.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Sunita</h5>

            <p class="designation">Educator</p>

            <!-- <p class="designation">PRT</p>

            <p class="experience">B.C.A.,B.Ed.<br>
              Experience – 6 Years</p> -->
          </div>
        </div>
      </div>


      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\samina.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Samina</h5>

            <p class="designation">Educator</p>

            <!-- <p class="designation">House Mistress</p>

            <p class="designation">Shelly House</p>

            <p class="designation">TGT</p>

            <p class="experience">M.A. , B.Ed.<br>
              Experience –&nbsp;4 Years</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/23.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Kuldeep</h5>

            <p class="designation">Sanskrit Faculty</p>

            <p class="designation">TGT</p>

            <p class="experience">M.A. , B.Ed.<br>
              Experience – 1 Year</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/24.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Rajni</h5>

            <p class="designation">French Faculty</p>

            <p class="designation">TGT</p>

            <p class="experience">M.A. , B.Ed.<br>
              Experience –&nbsp; 3 Years</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/25.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Priya</h5>

            <p class="designation">PRT</p>

            <p class="experience">M.Sc. , B.Ed.<br>
              Experience – 1 Year 6 Months</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/26.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Ritu</h5>

            <p class="designation">PRT</p>

            <p class="experience">M.A., B.Ed.<br>
              Experience – 4 Years</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/27.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Amanpreet</h5>

            <p class="designation">Art &amp; Craft Faculty</p>

            <p class="designation">TGT</p>

            <p class="experience">M.Com. , B.Ed.<br>
              Experience – 2 Years 6 Months</p>
          </div>
        </div>
      </div> -->

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/28.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Vikas</h5>

            <p class="designation">NIS Coach (Football)</p>

            <p class="designation">PTI</p>

            <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;2 Years</p>
          </div>
        </div>
      </div> -->

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\savita.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Savita</h5>

            <p class="designation">PTI</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\chandrika.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Chandrika</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\divya.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Divya</h5>

            <p class="designation">Coordinator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\kavita.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Kavita</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\manju.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Manju</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\poonam.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Poonam</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\reena.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Reena</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\sagar.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Sagar</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\samita.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Samita</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\simran.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Simran</h5>

            <p class="designation">Coordinator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="\assets\img\message\faculty\veenu.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Ms. Veenu</h5>

            <p class="designation">Educator</p>

            <!-- <p class="experience">B.P.Ed.<br>
              Experience –&nbsp;4 Year</p> -->
          </div>
        </div>
      </div>

      <!-- <div class="col-md-4 d-flex align-items-stretch">
        <div class="card">
          <div class="card-img"><img alt="" class="img-fluid" src="/assets/img/message/30.jpeg"></div>

          <div class="card-body">
            <h5 class="card-title">Mr. Mohit</h5>

            <p class="designation">Dance Faculty</p>

            <p class="experience">B.A.<br>
              Experience –&nbsp;2 years</p>
          </div>
        </div>
      </div> -->

      
    </div>
  </div>
</section>